import { GetPersonUser } from '@esportal/portal-service';

export const capitalize = (name: string): string =>
	name
		.toLowerCase()
		.split(' ')
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ');

export const getUserName = (userData: GetPersonUser | null): string => {
	if (userData?.portalUser.data.climapro.name) {
		return capitalize(userData.portalUser.data.climapro.name);
	} else if (userData?.identityKitUser.firstName) {
		return userData.identityKitUser.firstName;
	}
	return '';
};

export const getSurname1 = (userData: GetPersonUser | null): string => {
	if (userData?.portalUser.data.climapro.firstSurname) {
		return capitalize(userData.portalUser.data.climapro.firstSurname);
	} else if (userData?.identityKitUser.lastName) {
		return userData.identityKitUser.lastName;
	}
	return '';
};

export const getSurname2 = (userData: GetPersonUser | null): string => {
	if (userData?.portalUser.data.climapro.secondSurname && userData?.portalUser.data.climapro.firstSurname) {
		return capitalize(userData.portalUser.data.climapro.secondSurname);
	}

	return '';
};

export const getEmail = (userData: GetPersonUser | null): string => {
	if (userData?.identityKitUser.email) {
		return userData.identityKitUser.email;
	}
	return '';
};

export const getFechaAltaClub = (userData: GetPersonUser | null): string | null => {
	if (!userData?.portalUser) {
		return null;
	}

	return userData.portalUser.data.clubvw.fechaAltaClub;
};

export const getClubId = (userData: GetPersonUser | null): string => {
	if (userData?.portalUser.data.climapro.climaproId) {
		return userData.portalUser.data.clubvw.idMember;
	}

	return '';
};
